import { IRequestContext } from '@msdyn365-commerce/core';

export const isUserAuthenticated = (request: IRequestContext): boolean =>
    request.User?.IsAuthenticated === true || request.user.isAuthenticated === true;
